import { render, staticRenderFns } from "./copy_order.vue?vue&type=template&id=a543dfc2&scoped=true"
import script from "./copy_order.vue?vue&type=script&lang=js"
export * from "./copy_order.vue?vue&type=script&lang=js"
import style0 from "./copy_order.vue?vue&type=style&index=0&id=a543dfc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a543dfc2",
  null
  
)

export default component.exports